export const createURIs = (config) => {
    return config;
};
export const getUrl = (url, replacers = {}) => {
    // @ts-ignore
    let _url = url;
    Object.entries(replacers).forEach(([key, value]) => {
        _url.replace(key, value);
    });
    return _url;
};
